import { render, staticRenderFns } from "./ItemNeighbors.vue?vue&type=template&id=0da1e43b&"
import script from "./ItemNeighbors.vue?vue&type=script&lang=js&"
export * from "./ItemNeighbors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports